import vuex from 'vuex'
import Vue from 'vue'
Vue.use(vuex)

const fichatecnica = {
    namespaced: true,
    state: {
        permitenacional: false
        ,
        itemsclasificacion:[]
        ,indicador: null
        
    },
    actions: {        
        set_indicador({ commit }, payload) {            
            commit('SET_INDICADOR', payload.indicador)            
        },
        set_permitenacional({ commit }, payload) {            
                commit('SET_PERMITENACIONAL', payload.permitenacional)            
        },
        set_itemsclasificacion({ commit }, payload) { 
            commit('SET_ITEMSCLASIFICACION', payload.itemsclasificacion)
        }
    },
    mutations: {
        SET_PERMITENACIONAL(state, valor) {                        
            state.permitenacional = valor;
        },
        SET_ITEMSCLASIFICACION(state, valor) {
            state.itemsclasificacion = valor;
        },
        SET_INDICADOR(state, valor) {
            state.indicador = valor;
        }
    },
    getters: {
        gficha_permitenacional(state) {
            return state.permitenacional;
        },
        gficha_itemsclasificacion(state) {
            return state.itemsclasificacion;
        },
        gficha_indicador(state) {
            return state.indicador;
        },        
    }
}

export default fichatecnica;
